import { ReactNode } from "react";
import { useManualReviewEvents } from "./contexts/ManualReviewEventContext";
import { ExcludedPeriodsProvider } from "./contexts/ExcludedPeriodsContext";
import { MaterialExclusionProvider } from "./contexts/MaterialExclusionContext";
import { TimingExclusionProvider } from "./contexts/TimingExclusionContext";
import { TimelineExclusions } from "./hooks/useTimelineExclusions";

// The controls lock once changing an exclusion would cost something. Re-merging refetches,
// which reseeds the event provider, so edits made here would be discarded.
export const TimelineExclusionProviders = ({
  exclusions,
  locked = false,
  children,
}: Readonly<{
  exclusions: TimelineExclusions;
  locked?: boolean;
  children: ReactNode;
}>) => {
  const { editedSinceSeed } = useManualReviewEvents();
  return (
    <ExcludedPeriodsProvider
      excludedPeriodIds={exclusions.excludedPeriodIds}
      setExcludedPeriodIds={exclusions.setExcludedPeriodIds}
      exclusionsLocked={editedSinceSeed || locked}
    >
      <MaterialExclusionProvider
        materialExcludedPeriodIds={exclusions.materialExcludedPeriodIds}
        setMaterialExcludedPeriodIds={exclusions.setMaterialExcludedPeriodIds}
      >
        <TimingExclusionProvider
          timingExcludedPeriodIds={exclusions.timingExcludedPeriodIds}
          setTimingExcludedPeriodIds={exclusions.setTimingExcludedPeriodIds}
        >
          {children}
        </TimingExclusionProvider>
      </MaterialExclusionProvider>
    </ExcludedPeriodsProvider>
  );
};
